import { ComponentStyleConfig } from "@chakra-ui/react"
import { textV4Variants } from "../../components/TextV4/TextV4"

const textareaTheme: ComponentStyleConfig = {
  variants: {
    v4: {
      ...textV4Variants.v4_dekstop_d_headline,
      paddingY: "12px",
      paddingX: "16px",
      borderRadius: "8px",
      borderWidth: "1px",
      borderColor: "jarivis-neutral.50",
      color: "jarivis-neutral.50",
  
      transition: "all 0.2s ease",
  
      _focus: {
        borderColor: "Jarivis-Blue-Border",
      },
  
      /* Input Invalid */
      _invalid: {
        borderColor: "Jarivis-Danger-Border",
        color: "Jarivis-Danger-Border",
      },
  
      /* Form control invalid */
      _groupInvalid: {
        borderColor: "Jarivis-Danger-Border",
        color: "Jarivis-Danger-Border",
      },
  
      _disabled: {
        opacity: 0.75,
      },
    }
  },
}

export default textareaTheme